import { AxiosRequestConfig } from 'axios';
import cookie from 'cookie';
import { CookieName } from 'hooks/common/use-set-to-cookie';

/**
 * Audience / experiment headers for PDEX, read from the cookies at request time.
 *
 * Reading on every request instead of closing over a snapshot is what keeps this out of React:
 * there is nothing to go stale and nothing to re-register, so the interceptor can be registered
 * once at module load and cover even the first request of a page load.
 */
export const getExperimentHeaders = (config: AxiosRequestConfig): Record<string, string> => {
  if (typeof document === 'undefined') {
    return {};
  }

  const cookies = cookie.parse(document.cookie);
  const audiences = cookies[CookieName.Audiences];
  const ninetailed = cookies[CookieName.Experiments];

  const headers: Record<string, string> = {};

  // `withoutAudience` is deliberately not honoured: the header always went out before, and
  // honouring it now would change what subscriptions and cart receive.
  if (audiences && !config.headers?.audiences) {
    headers.audiences = audiences;
  }

  if (ninetailed && !config.withoutNinetailed) {
    headers.ninetailed = ninetailed;
  }

  return headers;
};
